import Icon from '@klv/atoms/icon';
import parse, { Element, domToReact } from 'html-react-parser';

import type { DOMNode, HTMLReactParserOptions } from 'html-react-parser';
import type { TIconName } from '@klv/atoms/icon/types';

const parser = (htmlBody: string ) => {

  const parserOptions: HTMLReactParserOptions = {
    replace: (domNode) => {
      if (domNode instanceof Element && (domNode.attribs?.class === 'table-cell-icon')) {
        const icon = domNode.attribs['data-icon-src'];
        return <Icon size={3.2} iconName={icon as TIconName}/>;
      }

      // Add the spacer row to the table head
      if (domNode instanceof Element && (domNode.name === 'thead')) {
        const tr = domNode.children.find((child) => child.type === 'tag' && child.name === 'tr') as Element;
        const columns = tr?.children.filter((child) => child.type === 'tag');
        return (
          <thead {...domNode.attribs} >
            {domNode instanceof Element ? domToReact((domNode as Element)?.children as DOMNode[]) : undefined}
            <tr className="thead-spacer">
              <td colSpan={columns.length} />
            </tr>
          </thead>
        );
      }

      // add the column count to the table via the data-columns attribute
      if (domNode instanceof Element && (domNode.name === 'table')) {
        const tableTbody = domNode.children.find((child) => child.type === 'tag' && child.name === 'tbody') as Element;
        const tableTbodyTr = tableTbody?.children.find((child) => child.type === 'tag' && child.name === 'tr') as Element;
        const tableTbodyTrColumnCount = tableTbodyTr?.children.filter((child) => child.type === 'tag').length;
        domNode.attribs['data-columns'] = tableTbodyTrColumnCount.toString();
        return domNode;
      }

      return null;
    },
  };

  return parse(htmlBody, parserOptions);
};

export default parser;
